<template>
  <div id="app">
    <head-menu @login="login" v-if="$route.name != 'app'"></head-menu>
    <!--        占位-->
    <div style="height: 80px" v-if="$route.name != 'app'"></div>
    <keep-alive>
      <router-view class="main" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="main" v-if="!$route.meta.keepAlive"></router-view>
    <!--        占位-->
    <div style="height: 60px" v-if="$route.name != 'app'"></div>
    <foot-menu v-if="$route.name != 'app'"></foot-menu>
  </div>
</template>
<script>
import header from './components/header/header'
import footer from './components/footer/footer'
import Login from './components/login/login'
import { vipInfo } from "./network/api";
import store from './store'

export default {
  name: 'App',
  components: {
    "head-menu": header,
    "foot-menu": footer,
    'Login': Login
  },
  data() {
    return {
      showContact: false,
      showTel: false,
      showLogin: false,
      isLogin: false,
      res_user_info: {},
    }
  },
  async mounted() {
     this.getVipInfo()
    if (window.localStorage.getItem("token")) {
      this.res_user_info = await store.dispatch('user/getInfo')
    }
  },
  methods: {
    contact() {
      this.showContact = !this.showContact;
      this.showTel = false;
    },
    login() {
      this.$login({});
    },
    getVipInfo() {
      vipInfo({version_code:'2.0.7'}).then(res => {
        window.localStorage.setItem("vipInfo",JSON.stringify(res.data.configMemberList[0]))
      })
    }
  }
}

</script>

<style lang="less" scoped>
  .iframe {
    width: 100%;
    height: 600px;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue